import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from './../assets/images/logo.png';

export default class TASBION extends Component {
  render() {
    return (
      <div className="container my-4 notification-100">

        <header className="text-center">
          <img src={logo} alt="KREP" style={{ borderRadius: '8px' }} />
          <h1 className="mt-2">TAS BION 10</h1>
        </header>

        {/* English Section */}
        <div className="section">
          <h3>English</h3>
          <ul>
            <li>
              <span className="label">1. Gazette Notification Number and Date:</span>{" "}
              S.O. 2346 (E) Dated 26.05.2025
            </li>

            <li>
              <span className="label">2. Title of Biostimulant:</span>{" "}
              Spirulina 10% (Liquid)
            </li>

            <li>
              <span className="label">3. Composition:</span>
              <ul>
                <li>(i) Spirulina powder: 10.0%</li>
                <li>(ii) Propylene glycol: 5.0%</li>
                <li>(iii) Lignin sulfonate: 5.0%</li>
                <li>(iv) Polysaccharide: 0.1%</li>
                <li>(v) Citric acid: 0.1%</li>
                <li>(vi) Water: QS</li>
                <li>(vii) Total: 100%</li>
              </ul>
            </li>

            <li>
              <span className="label">4. Crop:</span> Chilli and Tomato
            </li>

            <li>
              <span className="label">5. Doses:</span>
              <ul>
                <li>Two Foliar Sprays at 750 ml/ha.</li>
              </ul>
            </li>
          </ul>
        </div>

        {/* Hindi Section */}
        <div className="section">
          <h3>हिन्दी</h3>
          <ul>
            <li>
              <span className="label">1. राजपत्र अधिसूचना संख्या एवं दिनांक:</span>{" "}
              S.O. 2346 (E), दिनांक 26.05.2025
            </li>

            <li>
              <span className="label">2. जैव-उत्तेजक का नाम:</span>{" "}
              स्पिरुलिना 10% (तरल)
            </li>

            <li>
              <span className="label">3. संरचना:</span>
              <ul>
                <li>(i) स्पिरुलिना पाउडर : 10.0%</li>
                <li>(ii) प्रोपिलीन ग्लाइकोल : 5.0%</li>
                <li>(iii) लिग्निन सल्फोनेट : 5.0%</li>
                <li>(iv) पॉलीसैकराइड : 0.1%</li>
                <li>(v) साइट्रिक अम्ल : 0.1%</li>
                <li>(vi) पानी : आवश्यक मात्रा (QS)</li>
                <li>(vii) कुल : 100%</li>
              </ul>
            </li>

            <li>
              <span className="label">4. फसलें:</span> मिर्च एवं टमाटर
            </li>

            <li>
              <span className="label">5. मात्रा:</span>
              <ul>
                <li>750 मि.ली./हेक्टेयर की दर से दो पर्णीय (फोलियर) छिड़काव।</li>
              </ul>
            </li>
          </ul>
        </div>

        {/* Marathi Section */}
        <div className="section">
          <h3>मराठी</h3>
          <ul>
            <li>
              <span className="label">१. राजपत्र अधिसूचना क्रमांक व दिनांक:</span>{" "}
              S.O. 2346 (E), दिनांक 26.05.2025
            </li>

            <li>
              <span className="label">२. जैव-उत्तेजकाचे नाव:</span>{" "}
              स्पिरुलिना 10% (द्रव)
            </li>

            <li>
              <span className="label">३. घटकसंयोजन:</span>
              <ul>
                <li>(i) स्पिरुलिना पावडर : 10.0%</li>
                <li>(ii) प्रोपिलीन ग्लायकॉल : 5.0%</li>
                <li>(iii) लिग्निन सल्फोनेट : 5.0%</li>
                <li>(iv) पॉलीसॅकाराइड : 0.1%</li>
                <li>(v) सिट्रिक आम्ल : 0.1%</li>
                <li>(vi) पाणी : आवश्यक प्रमाणात (QS)</li>
                <li>(vii) एकूण : 100%</li>
              </ul>
            </li>

            <li>
              <span className="label">४. पीक:</span> मिरची व टोमॅटो
            </li>

            <li>
              <span className="label">५. मात्रा:</span>
              <ul>
                <li>750 मि.ली./हेक्टरी या प्रमाणात दोन पर्णीय (फोलिअर) फवारण्या.</li>
              </ul>
            </li>
          </ul>
        </div>

      </div>
    );
  }
}